import { useRouter } from 'next/router';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/getLocal';

export default function useOpenAiChat() {
    const router = useRouter();
    const { locale } = getLocal();

    const handleOpenChat = () => {
        // 使用固定的窗口名称 'ecoflowChat'，确保只打开一个窗口
        // 如果窗口已存在，会聚焦到该窗口而不是打开新的
        const chatUrl = `/${locale}/chat?source=${router.pathname}`;
        const windowName = 'ecoflowChat';
        const windowFeatures = 'width=1200,height=800,left=100,top=100,resizable=yes,scrollbars=yes';

        window.open(chatUrl, windowName, windowFeatures);

        gtm.push({
            event: 'uaEvent',
            event_name: 'click_on_chat',
            page_name: router.pathname,
            button_name: 'Start Chatting',
            navigation_name: `/${locale}/chat`,
            tag: '',

            __btn_type: 'common',
            __btn_id1: 'gtm-fix-icon',
            __btn_id2: 'gtm-fix-icon',
        });
    };
    return {
        handleOpenChat,
    };
}
